// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ap-container {
  max-width: 720px;
  max-height: 928px; /* 设置容器的最大高度，超出部分将可以滚动 */
  overflow-y: auto; /* 使容器的内容在超出容器高度时可以垂直滚动 */
  overflow-x: hidden;
  background-color: #cccccc;
}

/* 隐藏垂直滚动条 */
.ap-container::-webkit-scrollbar {
  display: none;
}


.ap-list {
  padding: 0%; /* 添加一些内边距，使内容不会贴紧边缘 */
}

.ap-block {
  position: relative;
  height: 88px;
  padding: 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #ccc;
}


/* 定义wifilogo位置 */
.wifi-icon {
  position: relative; /* 使用绝对定位 */
  top: -5px; /* 距离顶部 20px */
  left: 0px; /* 距离左侧 20px */
}

/* 定义more-icon位置 */
.more-icon{
  position: relative; /* 使用绝对定位 */
  top: 20px; /* 距离顶部 48px */
  right: -610px; /* 距离右侧 15px */
}

/* 定义security-icon位置 */
.security-icon{
  position: relative; /* 使用绝对定位 */
  top: -99px; /* 距离顶部 63px */
  right: -488px; /* 距离右侧 177px */
}

/* 定义 ap 名称 */
.ap-name {
  position: relative; /* 使用绝对定位 */
  left: 70px; /* 设置离左侧距离为 75px */
  top: -55px; /* 设置离顶部距离为 20px */
  color: #333; /* 文字颜色 */
  font-size: 28px; /* 字体大小 */
  font-weight: bold; /* 字体加粗 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  white-space: nowrap; /* 禁止换行 */
  white-space: nowrap; /* 防止内容换行 */
  text-overflow: ellipsis; /* 文本超出部分用省略号表示 */
  width: 380px; /* 设置宽度 */
}


/* 定义信号强度 */
.signal_strength {
  position: relative; /* 使用绝对定位 */
  top: -80px; /* 距离顶部 36px */
  right: -580px; /* 距离右侧 48px */
  color: #333; /* 文字颜色 */
  font-size: 18px; /* 字体大小 */
  white-space: nowrap; /* 防止文本换行 */
}



.ap-mfg_prefix{
  position: relative; /* 使用绝对定位 */
  top: -50px; /* 距离顶部 85px */
  left: 450px; /* 距离右侧 48px */
  color: #333; /* 文字颜色 */
  font-size: 18px; /* 字体大小 */
  white-space: nowrap; /* 防止文本换行 */
  text-align: right; /* 文本右对齐 */
  width: 200px; /* 设置宽度 */
}


.ap-value{
  position: relative; /* 使用绝对定位 */
  top: -75px; /* 距离顶部 85px */
  left: 0px; /* 距离右侧 48px */
  color: #333; /* 文字颜色 */
  font-size: 18px; /* 字体大小 */
  white-space: nowrap; /* 防止文本换行 */
}

.ap-details{
  height: 928px;
}`, "",{"version":3,"sources":["webpack://./src/css/APs.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB,EAAE,wBAAwB;EAC3C,gBAAgB,EAAE,yBAAyB;EAC3C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;;;AAGA;EACE,WAAW,EAAE,sBAAsB;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;;AAGA,iBAAiB;AACjB;EACE,kBAAkB,EAAE,WAAW;EAC/B,SAAS,EAAE,cAAc;EACzB,SAAS,EAAE,cAAc;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB,EAAE,WAAW;EAC/B,SAAS,EAAE,cAAc;EACzB,aAAa,EAAE,cAAc;AAC/B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,cAAc;EAC1B,aAAa,EAAE,eAAe;AAChC;;AAEA,aAAa;AACb;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,kBAAkB;EAC9B,UAAU,EAAE,kBAAkB;EAC9B,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB,EAAE,cAAc;EAChC,mBAAmB,EAAE,SAAS;EAC9B,mBAAmB,EAAE,WAAW;EAChC,uBAAuB,EAAE,iBAAiB;EAC1C,YAAY,EAAE,SAAS;AACzB;;;AAGA,WAAW;AACX;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,cAAc;EAC1B,aAAa,EAAE,cAAc;EAC7B,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,mBAAmB,EAAE,WAAW;AAClC;;;;AAIA;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,cAAc;EAC1B,WAAW,EAAE,cAAc;EAC3B,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,mBAAmB,EAAE,WAAW;EAChC,iBAAiB,EAAE,UAAU;EAC7B,YAAY,EAAE,SAAS;AACzB;;;AAGA;EACE,kBAAkB,EAAE,WAAW;EAC/B,UAAU,EAAE,cAAc;EAC1B,SAAS,EAAE,cAAc;EACzB,WAAW,EAAE,SAAS;EACtB,eAAe,EAAE,SAAS;EAC1B,mBAAmB,EAAE,WAAW;AAClC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".ap-container {\r\n  max-width: 720px;\r\n  max-height: 928px; /* 设置容器的最大高度，超出部分将可以滚动 */\r\n  overflow-y: auto; /* 使容器的内容在超出容器高度时可以垂直滚动 */\r\n  overflow-x: hidden;\r\n  background-color: #cccccc;\r\n}\r\n\r\n/* 隐藏垂直滚动条 */\r\n.ap-container::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n\r\n.ap-list {\r\n  padding: 0%; /* 添加一些内边距，使内容不会贴紧边缘 */\r\n}\r\n\r\n.ap-block {\r\n  position: relative;\r\n  height: 88px;\r\n  padding: 20px;\r\n  background-color: #ffffff;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n\r\n/* 定义wifilogo位置 */\r\n.wifi-icon {\r\n  position: relative; /* 使用绝对定位 */\r\n  top: -5px; /* 距离顶部 20px */\r\n  left: 0px; /* 距离左侧 20px */\r\n}\r\n\r\n/* 定义more-icon位置 */\r\n.more-icon{\r\n  position: relative; /* 使用绝对定位 */\r\n  top: 20px; /* 距离顶部 48px */\r\n  right: -610px; /* 距离右侧 15px */\r\n}\r\n\r\n/* 定义security-icon位置 */\r\n.security-icon{\r\n  position: relative; /* 使用绝对定位 */\r\n  top: -99px; /* 距离顶部 63px */\r\n  right: -488px; /* 距离右侧 177px */\r\n}\r\n\r\n/* 定义 ap 名称 */\r\n.ap-name {\r\n  position: relative; /* 使用绝对定位 */\r\n  left: 70px; /* 设置离左侧距离为 75px */\r\n  top: -55px; /* 设置离顶部距离为 20px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 28px; /* 字体大小 */\r\n  font-weight: bold; /* 字体加粗 */\r\n  overflow: hidden; /* 隐藏超出容器的内容 */\r\n  white-space: nowrap; /* 禁止换行 */\r\n  white-space: nowrap; /* 防止内容换行 */\r\n  text-overflow: ellipsis; /* 文本超出部分用省略号表示 */\r\n  width: 380px; /* 设置宽度 */\r\n}\r\n\r\n\r\n/* 定义信号强度 */\r\n.signal_strength {\r\n  position: relative; /* 使用绝对定位 */\r\n  top: -80px; /* 距离顶部 36px */\r\n  right: -580px; /* 距离右侧 48px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 18px; /* 字体大小 */\r\n  white-space: nowrap; /* 防止文本换行 */\r\n}\r\n\r\n\r\n\r\n.ap-mfg_prefix{\r\n  position: relative; /* 使用绝对定位 */\r\n  top: -50px; /* 距离顶部 85px */\r\n  left: 450px; /* 距离右侧 48px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 18px; /* 字体大小 */\r\n  white-space: nowrap; /* 防止文本换行 */\r\n  text-align: right; /* 文本右对齐 */\r\n  width: 200px; /* 设置宽度 */\r\n}\r\n\r\n\r\n.ap-value{\r\n  position: relative; /* 使用绝对定位 */\r\n  top: -75px; /* 距离顶部 85px */\r\n  left: 0px; /* 距离右侧 48px */\r\n  color: #333; /* 文字颜色 */\r\n  font-size: 18px; /* 字体大小 */\r\n  white-space: nowrap; /* 防止文本换行 */\r\n}\r\n\r\n.ap-details{\r\n  height: 928px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
